<template>
	<div class="o-wrap">
		<el-page-header  @back="$router.go(-1)" content="视频发布" />
		<el-form label-width="140px" :model="form" ref="form" :rules="rules">
			<el-form-item label="请选择发布平台">
				<div class="checkFlex">
					<div :class="['checkBox',form.pushPlat.includes(item.name)?'active':'']" v-for="(item,index) in list"
						:key="item.id">
						<div class="checkTop " @click="selectFun(item.name,item.text2)">
							<img :src="item.url" alt="">
							{{item.title}}
						</div>
						<div class="checkBot" v-if="item.text2 == '' || item.text2 == null"  @click="binding(item.id,item.title,item.name)">
							{{item.text}}
							<i class="el-icon-edit"></i>
						</div>
						<div class="checkBot text2" v-else  >
							{{item.text2}}
						</div>
					</div>
				</div>
			</el-form-item>
			<el-form-item label="上传视频" prop="scsp">
				<el-upload class="upload-demo uploadVideo" :action='videoUrl'  multiple
					accept="video/mp4"
					:show-file-list="false"
						element-loading-text="拼命加载中……"
						:on-progress="changeVideo"
						:before-upload="beforeAvatarUploadVideo"
						 :data="fileVideo"
						 :headers="headers" 
						:on-success="handleSuccessVideo" >
					<img v-if="imgUrlVideo" :src="imgUrlVideo"  :onerror="imgSrc" class="avatar">
					<div v-else>
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">点击上传</div>
					</div>
					<el-progress v-if="progressFlag" :percentage="loadProgress"></el-progress>
					<div class="el-upload__tip" slot="tip">只能上传video文件，且不超过1GB</div>
				</el-upload>
			</el-form-item>
			<el-form-item label="封面图" >
				<el-upload class="avatar-uploader" :action="imgUrl" :show-file-list="false"
					element-loading-text="拼命加载中……" :on-progress="changePic" :before-upload="beforeUploadPic"
					v-loading.fullscreen.lock="loading" :data="fileInfoPic" :on-success="handleSuccessPic"
					accept="image/jpeg,image/png">
					<img v-if="imgUrlPic" :src="imgUrlPic" :onerror="imgSrc" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				<div class="tishinews">
					小提示：上传图片只能是JPG/PNG格式且上传图片大小不能超过 5MB！
					<br />图片建议尺寸≥1146x717，最低尺寸≥960x600
				</div>
			</el-form-item>
			<el-form-item label="视频主题" prop="title">
				<el-input v-model="form.title" placeholder="请输入视频主题" />
			</el-form-item>
			<el-form-item label="视频副标题"  v-if="form.pushPlat.includes('bili')">
				<el-input placeholder="请输入视频副标题" v-model="form.subTitle" />
			</el-form-item>
			<el-form-item label="视频分区 " v-if="form.pushPlat.includes('bili')"  >
				<el-cascader
				    v-model="form.tid"
				    :options="spList"
					 ref="nodeName"
					:props="spListProps2"
				    @change="handleChange">
				</el-cascader>
			</el-form-item>
			<el-form-item label="中链企通类目" v-if="form.pushPlat.includes('zlqt')">
				<el-select v-model="form.zlqtCate" placeholder="请选择" :props="{expandTrigger:'hover'}">
				    <el-option
				      v-for="item in zloptions"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				  </el-select>
			</el-form-item>
			<el-form-item label="消毒设备网类目" v-if="form.pushPlat.includes('xdsb')">
				<el-select v-model="form.xdsbCate" placeholder="请选择"  :props="{expandTrigger:'hover'}">
				    <el-option
				      v-for="item in xdoptions"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				  </el-select>
			</el-form-item>
			<el-form-item label="环境服务业商会类目" v-if="form.pushPlat.includes('com')">
				<el-select v-model="form.comCate" placeholder="请选择"  :props="{expandTrigger:'hover'}">
				    <el-option
				      v-for="item in comoptions"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				  </el-select>
			</el-form-item>
			<div class="submit-wrap">
				<el-button type="primary" @click="handleSubmit">提交</el-button>
			</div>
		</el-form>
		<el-dialog  width="80%" :visible.sync="dialogTableVisible" :before-close="handleClose">
			<!-- <iframe :src="this.txtUrl" frameborder="0" width="100%"  scrolling="auto"></iframe> -->
		</el-dialog>
		<el-dialog  width="476px" :visible.sync="dialogTab" :before-close="handleCloseB">
			<div class="dialogBox">
				<div class="title">
					{{title}}账号绑定
				</div>
				<div class="forms">
					<el-form ref="forms" :model="forms" label-width="80px">
					  <el-form-item label="账号">
					    <el-input v-model="forms.phone" placeholder="请输入账号"></el-input>
					  </el-form-item>
					  <el-form-item label="密码">
					    <el-input v-model="forms.password" placeholder="请输入密码"></el-input>
					  </el-form-item>
					  <el-form-item class="onBtn">
					      <el-button type="primary" @click="onSubmit(name)">绑定</el-button>
					  </el-form-item>
					</el-form>
				</div>
			</div>
		</el-dialog>
		
	</div>
</template>
<script>
	import Axios from 'axios'
	export default {
		data() {
			return {
				imgUrl:this.$store.state.VIDEO_URL+"/files/upload",
				videoUrl:this.$store.state.VIDEO_URL+"/video/upload",
				spList:[],
				spListProps2: {
					value: 'id',
					label: 'name',
					children: 'children',
				},
				zloptions:[],
				xdoptions:[],
				comoptions:[],
				headers:{
					Accept:"*/*",
				},
				getSet:'',
				txtUrl:'',
　　			loadProgress: 0, // 动态显示进度条
				progressFlag: false, // 关闭进度条
				imgSrc:this.$store.state.IMG_URL + "mr.jpg",
				imgUrlVideo:'',
				imgUrlPic:'',
				loading:false,
				name: '',
				title:'',
				fileVideo:{
					type:"video",
				},
				fileInfoPic:{
					type:"thumb"
				},
				list: [{
						id: '1',
						title: '抖音',
						name:'tiktok',
						url: require('@/assets/img/dy.png'),
						text: '绑定账号',
						text2:''
					},
					{
						id: '2',
						title: '快手',
						name:'kwai',
						url: require('@/assets/img/ks.png'),
						text: '绑定账号',
						text2:''
					},
					// {
					// 	id: '3',
					// 	title: '',
					// 	name:'bili',
					// 	url: require('@/assets/img/b.png'),
					// 	text: '绑定账号',
					// 	text2:''
					// },
					{
						id: '4',
						title: '中链',
						name:'zlqt',
						url: require('@/assets/img/zl.png'),
						text: '绑定账号',
						text2:''
					},
					{
						id: '5',
						title: '消毒',
						name:'xdsb',
						url: require('@/assets/img/xd.png'),
						text: '绑定账号',
						text2:''
					},
					{
						id: '6',
						title: '商会',
						name:'com',
						url: require('@/assets/img/sh.png'),
						text: '绑定账号',
						text2:''
					},
				],
				form: {
					userId:this.$store.state.USER_ID, //用户ID
					// userId:16, //用户ID
					pushPlat: [], // 已选列表
					videoPath:'',
					thumb:'',
					zlqtCate: "", //中链企通环保网分类ID
					xdsbCate: "", //消毒设备网分类ID
					comCate: "" ,//商会分类ID
					tid:'',
					title: "" ,//标题
					subTitle: "", //副标题
					
				},
				forms:{
					userId:this.$store.state.USER_ID, //用户ID
					// userId:16, //用户ID
					phone: "", //手机号
					type: "", //默认 xdsb, xdsb: 消毒设备网, com: 商会
					password: "" //密码
				},
				dialogTab:false,
				dialogTableVisible: false,
				rules: {
					scsp: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.videoPath === '') {
								callback(new Error('请上传视频'));
							} else {
								callback();
							}
						}
					}],
					title: [{
						required: true,
						message: '请输入视频主题'
					}],
				}
			}

		},
		created() {
			this.getzt()
		},
		computed: {
			// 被选中项的集合
			ChooseList() {
				return this.list.filter((item) => {
					if (this.form.pushPlat.includes(item.name)) {
						return item
					}
				})
			},
		},
		methods: {
			handleChange(){
				let nodesObj = this.$refs['nodeName'].getCheckedNodes()[0]
				this.form.tid = nodesObj.path[nodesObj.path.length-1]
			},
			onSubmit(type){
				this.$refs['form'].validate(valid => {
					let forms = {
						userId:this.$store.state.USER_ID, //用户ID
						// userId:16, //用户ID
						phone: this.forms.phone, //手机号
						type:type, //默认 xdsb, xdsb: 消毒设备网, com: 商会
						password:this.forms.password //密码
					}
					Axios.post(this.$store.state.VIDEO_URL+'/api/authorize/getPlatformAuth',JSON.parse(JSON.stringify(forms))).then(data => {
						let datas = data.data
						if(datas.code == "1000"){
							this.$message.success('绑定成功！');
							this.dialogTab = false
						}else{
							this.$message.error(datas.message);
						}
					})
				});
				
			},
			handleClose(){
				// this.dialogTableVisible=false
				clearInterval(this.getSet)
			},
			handleCloseB(){
				this.dialogTab=false
			},
			getzt(){
				this.$axios.get(this.$store.state.VIDEO_URL+'/api/getAuthList?userId='+this.$store.state.USER_ID+'&type=').then(data => {
					let datas = data.data
					if(data.code == "1000"){
						this.list[0].text2 = datas.authTiktok.nickName
						this.list[1].text2 = datas.authKwai.nickName
						// this.list[2].text2 = datas.authBili.nickName
						this.list[2].text2 = datas.userName
						this.list[3].text2 = datas.authXdsb.nickName
						this.list[4].text2 = datas.authCommerce.nickName
					}
				})
			},
			getPlatformCate(name){
				this.$axios.get(this.$store.state.VIDEO_URL+'/api/video/getPlatformCate?userId='+this.$store.state.USER_ID+'&type='+name).then(data => {
					let datas = data.data
					if(data.code == "1000"){
						let option = datas
						option.forEach((item,index)=>{
							item.label = item.ncatTitle
							item.value = item.id
						})	
						if(name = "zlqt"){
							this.zloptions = option
						}
						if(name = "zdsb"){
							this.xdoptions = option
						}
						if(name = "com"){
							this.comoptions = option
						}	
						
					}else{
						that.$message.error(datas.message);
					}
					
					
				})
			},
			uploadVideoProcess(event, file, fileList) {
			          this.progressFlag = true; // 显示进度条
			          this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
			          if (this.loadProgress >= 100) {
			              this.loadProgress = 100
			              setTimeout( () => {this.progressFlag = false}, 1000) // 一秒后关闭进度条
			          }
			},
			getBilibli (name){
				this.$axios.get(this.$store.state.VIDEO_URL+'/api/bilibli/geType?userId='+this.$store.state.USER_ID+'&parentId=0').then(data => {
					let datas = data.data
					if(datas.code == "1000"){
						let dataList = datas.data
						dataList.forEach(item => {
							if (!item.children.length) {
								delete item.children
							}
							item.children.forEach(items => {
								if(!items.children.length){
									delete items.children
								}
							})
							
						})
						this.spList = dataList
					}
				})
				
			},
			selectFun(name,text2) {
				if(text2 != "" && text2 != null){
					if (!this.form.pushPlat.includes(name)) {
						this.form.pushPlat.push(name) // 判断已选列表中是否存在该id，不是则追加进去
						if(name == "zlqt" || name == "xdsb" || name == "com"){
							this.getPlatformCate(name)
						}
						if(name == "bili"){
							this.getBilibli(name)
						}
					} else {
						let index = this.form.pushPlat.indexOf(name) // 求出当前id的所在位置
						this.form.pushPlat.splice(index, 1) // 否则则删除
					}
				}else{
					this.$alert('请先绑定账号', '提示', {
					  confirmButtonText: '确定',
					});
					

				}
				
			},
			// 绑定
			binding(id,title,name) {
				this.name = title
				if(id != "4" && id!= "5" && id != "6"){
					this.$axios.get(this.$store.state.VIDEO_URL+'/api/authorize/getAuthCode?userId='+this.$store.state.USER_ID+'&type='+name).then(data => {
						let datas = data.data
						if(data.code == "1000"){
							const newWindow = window.open(datas.url, undefined, "width='40%',height='40%',left=50,top=50")
							let that = this
							this.getSet = setInterval(function(){
								Axios.get(that.$store.state.VIDEO_URL+'/api/getAuthByType?userId='+that.$store.state.USER_ID+'&state='+data.data.state).then(res => {
									let resDate = res.data
									if(resDate.code == "200"){
										clearInterval(that.getSet)
										that.getzt()
										newWindow.close()
									}else if(resDate.code == "204"){
										if(newWindow.closed){
											clearInterval(that.getSet)
										}
									}else{
										clearInterval(that.getSet)
										that.$message.error(resDate.message);
									}
								})
							},1000)
							
							this.txtUrl = datas.url
						}
					})
				}else{
					this.dialogTab = true
					this.title = title
					this.name = name
					
				}
			},
			handleSubmit() {
				this.$refs['form'].validate(valid => {
					if(valid){
						Axios.post(this.$store.state.VIDEO_URL+'/api/video/push',JSON.parse(JSON.stringify(this.form))).then(data => {
							let datas = data.data
							if(datas.code == "1000"){
								this.$message.success('成功！');
								this.$router.push('/video')
							}else{
								this.$message.error(datas.message);
							}
						})
					}
					
				});
			},
			changePic(event, file, fileList){
				this.loading = true;
			},
			beforeUploadPic(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG/PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return (isJPG || isPNG) && isLt5M;
			},
			handleSuccessPic(res, file) {
				if (res.code == "1000") {
					this.loading = false;
					this.form.thumb = res.data.uri
					this.imgUrlPic = res.data.thumb
				} else {
					this.loading = false;
					this.$message.error(res.message);
				}
			},
			changeVideo(event, file, fileList){
				// this.loading = true;
				this.progressFlag = true; // 显示进度条
				  this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
				  if (this.loadProgress >= 100) {
					  this.loadProgress = 100
					  setTimeout( () => {this.progressFlag = false}, 1000) // 一秒后关闭进度条
				  }
			},
			beforeAvatarUploadVideo(file) {
				const isLt1GB = file.size / 1024 / 1024 < 1024;
				if (!isLt1GB) {
					this.$message.error('上传视频大小不能超过1GB!');
				}
				return isLt1GB;
			},
			handleSuccessVideo(res, file) {
				if(res.code = "1000"){
					// this.loading = false;
					this.form.videoPath = res.data.uri
					// this.imageUrl = URL.createObjectURL(file.raw);
					this.imgUrlVideo = res.data.thumb
				}else{
					// this.loading = false;
					this.$message.error(res.data);
				}
			},
		},
		 beforeDestroy() {
		    clearInterval(this.getSet) // 清除定时器
		}
	}
</script>
<style >
	.checkFlex {
		display: flex;
	}

	.checkBox {
		position: relative;
	}

	.checkFlex .active::after {
		content: "";
		position: absolute;
		width: 30px;
		height: 30px;
		background: url("../../assets/img/active.png") no-repeat;
		left: 0;
		top: 0;
	}

	.checkBox {
		width: 110px;
		height: 100px;
		margin: 0 10px;
		
		/* background-color: #000; */
		border: 1px solid #ccc;
	}

	.checkTop {
		width: 110px;
		height: 66px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #333;
		font-size: 20px;
		font-weight: bold;
		border: 1px dashed #d9d9d9;
	}

	.checkTop img {
		width: 32px;
		height: 32px;
		margin-right: 5px;
	}

	/* .checkBox:nth-child(3) .checkTop img {
		width: 100px;
	} */

	.checkBot {
		line-height: 34px;
		font-size: 16px;
		color: #333;
		text-align: center;
	}

	.el-checkbox {
		width: 110px;
		height: 70px;
	}

	.el-checkbox-group {
		display: flex;
	}

	.el-upload {}

	.el-icon-upload {
		font-size: 40px;
	}

	.el-upload {
		width: 178px;
		height: 178px;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	/* .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
		border-radius: 6px;
		border: 1px dashed #d9d9d9;
	} */
	/* .dialogBox {
		display: flex;
		justify-content: space-between;
	}

	.dialogBox .leftBox {
		width: 30%;
		text-align: center;
		border-right: 1px dashed #ccc;
	}

	.dialogBox .rightBox {
		width: 70%;
		text-indent: 80px;
	}

	.dialogBox .rightBox .title {
		text-indent: 40px;
	} */
	.onBtn .el-form-item__content{
		margin: 0 auto;
		margin-left: 0 !important;
		text-align: center;
	}
	.dialogBox .title {
		text-align: center;
		font-size: 16px;
		font-weight: bold;
	}
	.el-input .el-input__inner{
		width: 300px !important;
	}
	
	iframe{
		height: 78vh;
	}
	.text2{
		font-size: 14px;
		color: #0194fe;
		width: 105px;
		height: 34px;
		margin: 0 auto;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.forms{
		margin: 30px 0;
	}
	.submit-wrap{
		text-indent: 300px;
	}
	.el-form{
		margin-top: 20px !important;
	}
	.el-form-item{
		margin-bottom: 40px !important;
	}
	.avatar{
		width: 213px;
		height: 120px;
	}
	
</style>